import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

const DescriptionPage = ({
  children,
  variantPrimary = "body1",
  variantSecondary = "body2",
  sx,
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Typography
      variant={isMobile ? variantSecondary : variantPrimary}
      component="h6"
      sx={{ color: "#878383", fontWeight: 300, mb: 2, ...sx }}
    >
      {children}
    </Typography>
  );
};

export default DescriptionPage;
